import React, { useState, useEffect } from 'react';
import { X, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const GetStartedModal = ({ isOpen, onClose }) => {
  const [form, setForm] = useState({ name: '', phone: '', email: '' });
  const [consent, setConsent] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setForm({ name: '', phone: '', email: '' });
      setConsent(false);
      setSubmitted(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API_URL}/api/query`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          email: form.email,
          service: 'General Inquiry',
          category: 'Get Started',
        }),
      });
    } catch (err) {
      console.error('Form submission failed:', err);
    }
    setSubmitted(true);
  };

  return (
    <div className="gs-modal-overlay" data-testid="getstarted-modal" onClick={onClose}>
      <div className="gs-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="gs-modal-close" data-testid="getstarted-modal-close" onClick={onClose}>
          <X size={22} />
        </button>

        {!submitted ? (
          <>
            <h2 className="gs-modal-title">Get Expert Assistance</h2>
            <p className="gs-modal-subtitle">Share your details and our team will reach out within 24 hours</p>
            <form className="getstarted-form" onSubmit={handleSubmit} data-testid="getstarted-modal-form">
              <div className="gs-form-group">
                <label className="gs-label">Name *</label>
                <input
                  type="text"
                  className="gs-input"
                  data-testid="gs-modal-name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Your full name"
                  required
                />
              </div>
              <div className="gs-form-group">
                <label className="gs-label">Mobile *</label>
                <input
                  type="tel"
                  className="gs-input"
                  data-testid="gs-modal-phone"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  placeholder="+91 XXXXX XXXXX"
                  required
                />
              </div>
              <div className="gs-form-group">
                <label className="gs-label">Email *</label>
                <input
                  type="email"
                  className="gs-input"
                  data-testid="gs-modal-email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="your@email.com"
                  required
                />
              </div>
              <div className="gs-consent-group">
                <label className="gs-consent-label">
                  <input
                    type="checkbox"
                    className="gs-consent-checkbox"
                    data-testid="gs-modal-consent"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    required
                  />
                  <span>I consent to receiving WhatsApp messages and emails from APK FINTECH regarding my query.</span>
                </label>
              </div>
              <Button type="submit" className="btn-primary gs-submit" data-testid="gs-modal-submit" disabled={!consent}>
                Submit Request <ArrowRight size={18} />
              </Button>
            </form>
          </>
        ) : (
          <div className="gs-modal-success" data-testid="gs-modal-success">
            <CheckCircle size={56} className="success-icon" />
            <h2 className="success-title">Request Submitted!</h2>
            <p className="success-text">
              Thank you, {form.name}! Our team will reach out to you within 24 hours.
            </p>
            <Button className="btn-primary" onClick={onClose}>
              Close
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GetStartedModal;
